export default "<notifier-container></notifier-container>\n<fir-list *ngIf='fir$'></fir-list>\n<router-outlet></router-outlet>"